import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "../../components/Seo";
import { Avatar, EmptyState, LoadMore, PageHeader, SegmentTabs, Spinner, usePagedList } from "../../components/lawyer/LawyerUi";
import { lawyerService } from "../../services/lawyerApi";

const serviceLabel = (item) => {
  if (item.period === "monthly") return "Monthly Subscription";
  if (item.period === "weekly") return "Weekly Subscription";
  return "One Time Service";
};

const amount = (item) => {
  const value = Number(item.lawyer_pay_amount ?? item.pay_amount) || 0;
  return `${Number(value.toFixed(2))} ${item.currency || "USD"}`;
};

const ClientRow = ({ item }) => {
  const active = item.status === "Active";
  const chatId = item.chat?.id;
  const content = (
    <>
      <Avatar src={item.user?.picture} alt={item.user?.name} size={64} />
      <span className="lwp-client-body">
        <strong>{item.user?.name || "Client"}</strong>
        <span className={active ? "lwp-client-type active" : "lwp-client-type"} title={item.status}>
          {serviceLabel(item)}
        </span>
      </span>
      <span className="lwp-client-side">
        {chatId ? <i className="bi bi-chevron-right" /> : <span />}
        {Number(item.chat_unread) > 0 && <span className="lwp-unread">{item.chat_unread}</span>}
        <span className="lwp-client-amount">{amount(item)}</span>
      </span>
    </>
  );

  return chatId ? (
    <Link to={`/lawyer/clients/${chatId}`} className="lwp-client-row">
      {content}
    </Link>
  ) : (
    <div className="lwp-client-row disabled" title="No conversation yet">
      {content}
    </div>
  );
};

const LawyerClients = () => {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "inactive" ? "inactive" : "active";
  const list = usePagedList((p) => lawyerService.getSubscriptions(tab, p), (d) => d.items, [tab]);

  return (
    <div className="lwp-page lwp-page-narrow">
      <Seo title="My Clients | Legal Platform" noindex />
      <PageHeader title="My Clients" />
      <SegmentTabs
        label="Client status"
        value={tab}
        onChange={(key) => setParams(key === "inactive" ? { tab: key } : {}, { replace: true })}
        tabs={[
          { key: "active", label: "Active", count: Number(list.meta.active_count) || 0 },
          { key: "inactive", label: "Inactive", count: Number(list.meta.inactive_count) || 0 },
        ]}
      />
      <div className="lwp-tab-body">
        {list.loading ? (
          <Spinner />
        ) : list.meta.error ? (
          <EmptyState icon="bi-exclamation-circle" text={list.meta.error} />
        ) : list.items.length === 0 ? (
          <EmptyState
            icon="bi-people"
            text={tab === "active" ? "No active clients right now." : "No past clients yet."}
          />
        ) : (
          <>
            <ul className="lwp-card-list">
              {list.items.map((item) => (
                <li key={item.id}>
                  <ClientRow item={item} />
                </li>
              ))}
            </ul>
            <LoadMore list={list} />
          </>
        )}
      </div>
    </div>
  );
};

export default LawyerClients;
